import React, { Fragment, useEffect } from 'react';
import { metrics } from '@atlassian/browser-metrics';
import { useAIAnswerContext } from './ai-answer-context';

/**
 * @deprecated use 'aiAnswerDialogMetric' from common instead
 */
export var aiAnswerDialogMetric = metrics.pageSegmentLoad({
  key: 'ai-search-dialog'
}); // Product is automatically prepended to the key

/**
 * @deprecated use 'MarkAIAnswerDialogMetricEnd' from common instead
 */
export var MarkAIAnswerDialogMetricEnd = function MarkAIAnswerDialogMetricEnd() {
  var _useAIAnswerContext = useAIAnswerContext(),
    isReadingAids = _useAIAnswerContext.isReadingAids,
    commonAttributes = _useAIAnswerContext.commonAttributes;
  var source = commonAttributes.source;
  useEffect(function () {
    aiAnswerDialogMetric.stop({
      customData: {
        isReadingAids: !!isReadingAids,
        source: source
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(Fragment, null);
};